import { Capacitor } from '@capacitor/core';

export const isNativeCap = Capacitor.isNativePlatform();